import { Component, Input } from '@angular/core';
import { PersonPositionSearchResult } from 'src/app/people/models/personPositionSearchResult';

@Component({
  selector: 'app-position-search-result',
  templateUrl: './position-search-result.component.html',
  styleUrls: ['./position-search-result.component.scss'],
  standalone: false
})
export class PositionSearchResultComponent {
  @Input() person: PersonPositionSearchResult;
}
